/** @typedef {import('../types/models').Wallet} Wallet */
/** @typedef {import('../types/api').ApiResponse} ApiResponse */

import { instance } from '../config/api';

/** @returns {Promise<ApiResponse<Wallet[]>>} */
const fetchCollectionsWallets = async () => {
  const { data } = await instance.get('wallet');
  return data;
};
export { fetchCollectionsWallets };
